module.exports = __webpack_public_path__ + "img/icon_fileDownload@3x.22db6181.png";